import { useEffect, useState } from 'react';

import FormSubmitButton from '@/components/Forms/FormSubmitButton';
import UpdateContactsForm from '@/pages/(guarded)/settings/components/UpdateContactsForm';
import useMe from '@/renderer/utils/useMe';

export default StepTwo;

type StepTwoProps = {
  onSuccess: () => void;
  onSkip: () => void;
};

// Step two component
function StepTwo({ onSuccess, onSkip }: StepTwoProps) {
  const [user, setUser] = useMe(true);
  const [successCount, setSuccessCount] = useState(0);

  useEffect(() => {
    if (user?.contactSecondary && user.contactTertiary) {
      onSuccess();
    }
  }, [onSuccess, user?.contactSecondary, user?.contactTertiary]);

  return (
    <div className="space-y-4">
      {!!user && (
        <UpdateContactsForm
          user={user}
          setUser={setUser}
          onSuccess={() => setSuccessCount((value) => value + 1)}
          name="contactSecondary"
          onlyVerify
          full
        />
      )}
      {!!user && (
        <UpdateContactsForm
          user={user}
          setUser={setUser}
          onSuccess={() => setSuccessCount((value) => value + 1)}
          name="contactTertiary"
          onlyVerify
          full
        />
      )}

      {successCount >= 2 ? (
        <FormSubmitButton onClick={onSkip}>Done! See your dashboard</FormSubmitButton>
      ) : (
        <button
          type="button"
          onClick={onSkip}
          className="w-full rounded-sm border-0 bg-transparent px-3 py-2.5 text-sm font-semibold ring-1 ring-zinc-500 hover:ring-zinc-400"
        >
          Skip for now
        </button>
      )}
    </div>
  );
}
